<template>
    <SoliForm
        v-if="purchaseOption"
        ref="form"
        :title="`Edit ${isMembership ? 'Membership' : 'Pass'}`"
        :saveChanges="!prorationLoading"
        :hideBtn="!Object.values(editMode).some((e) => e)"
        @reset="$emit('reset')"
        @submit="updateSubscription()"
    >
        <template #body>
            <v-list v-if="!Object.values(editMode).some((e) => e)">
                <SoliBtn
                    v-if="isMembership"
                    block
                    text="Withdraw with 30 Days Notice"
                    color="soli-grey"
                    @click="
                        [
                            (editMode.withdraw30 = true),
                            getExitProration(),
                            getFinalClass(),
                        ]
                    "
                    outlined
                    class="mb-3"
                ></SoliBtn>
                <SoliBtn
                    v-if="isMembership"
                    block
                    text="Cancel at End of Billing Period"
                    color="soli-grey"
                    @click="
                        [
                            (editMode.endOfCycle = true),
                            //(showEoMWarning = true),
                            getFinalClass(),
                        ]
                    "
                    outlined
                    class="mb-3"
                ></SoliBtn>
                <!--<SoliBtn
                        block
                        text="Change Billing Date"
                        color="soli-grey"
                        @click="editMode = 'changeDate'"
                        outlined
                        class="mb-3"
                    ></SoliBtn>-->
                <SoliBtn
                    v-if="isMembership"
                    block
                    text="Cancel Now"
                    color="soli-grey"
                    @click="editMode.cancelNow = true"
                    outlined
                    class="mb-3"
                ></SoliBtn>
                <SoliBtn
                    v-if="isMembership && purchaseOption.canUpgrade"
                    block
                    text="Upgrade or Downgrade Membership"
                    color="soli-grey"
                    @click="$emit('changePrice')"
                    outlined
                    class="mb-3"
                ></SoliBtn>
                <SoliBtn
                    block
                    text="Change Price and Tags"
                    color="soli-grey"
                    @click="$emit('editDetails')"
                    outlined
                    class="mb-3"
                ></SoliBtn>
                <SoliBtn
                    v-if="purchaseOption.pendingExit"
                    :loading="removeExitLoading"
                    block
                    outlined
                    text="Remove Pending Exit Form"
                    color="soli-grey"
                    class="mb-3"
                    @click="removePendingExit(purchaseOption)"
                ></SoliBtn>
            </v-list>
            <SoliDate
                v-if="editMode.withdraw30"
                @input="[getExitProration(), getFinalClass()]"
                label="Date of Notice"
                v-model="dateOfNotice"
                :max="getSubscriptionCycleMax(purchaseOption.cycle)"
                :min="
                    globalMomentISO(purchaseOption.starts_at) >
                    globalMomentISOStartOfMonth(new Date())
                        ? globalMomentISO(purchaseOption.starts_at)
                        : globalMomentISOStartOfMonth(new Date())
                "
                :rules="[
                    (val) => (val || '').length > 0 || 'This field is required',
                ]"
            ></SoliDate>
            <div v-if="editMode.withdraw30" class="soli-grey pb-5 px-1">
                Which lessons will be cancelled?
            </div>
            <v-btn-toggle
                v-if="editMode.withdraw30"
                v-model="cancelAll"
                mandatory
                class="w-full"
            >
                <v-col cols="12" class="pa-0 ma-0">
                    <SoliBtn
                        block
                        :text="'Cancel lessons after exit date'"
                        color="soli-grey"
                        :value="false"
                        outlined
                        class="mb-3"
                    ></SoliBtn>
                    <SoliBtn
                        block
                        text="Cancel all lessons"
                        color="soli-grey"
                        :value="true"
                        outlined
                        class="mb-3"
                    ></SoliBtn>
                </v-col>
            </v-btn-toggle>

            <div v-if="editMode.cancelNow" class="soli-grey pb-5 px-1">
                {{
                    `${purchaseOption.name} and all of its lessons will be cancelled immediately. If a refund should be issued, you'll still need to process it separately. This can't be undone.`
                }}
            </div>

            <div v-if="editMode.endOfCycle" class="soli-grey pb-5 px-1">
                {{
                    `${purchaseOption.name} will terminate at the end of the billing period.`
                }}
            </div>

            <div
                v-if="
                    editMode.withdraw30 ||
                    editMode.cancelNow ||
                    editMode.endOfCycle
                "
            >
                <v-switch
                    label="Email Student"
                    v-model="emailStudent"
                    class="mb-3"
                    dense
                ></v-switch>
                <v-switch
                    label="Email Teacher"
                    v-model="emailTeacher"
                    class="pt-0 mb-3 mt-0"
                    dense
                ></v-switch>

                <div v-if="editMode.withdraw30" class="soli-grey pa-3 mb-3 row">
                    <div class="w-full">
                        {{
                            `Membership End Date: ${globalMomentDate(cancelAt)}`
                        }}
                    </div>

                    Final Invoice Amount:
                    <div v-if="!prorationLoading" class="mx-2">
                        {{ formatUnitAmount(exitProration) }}
                    </div>
                    <v-progress-circular
                        v-if="prorationLoading"
                        indeterminate
                        :size="25"
                        color="primary"
                        class="mx-3"
                    ></v-progress-circular>
                    <div v-if="!cancelAll">
                        {{
                            `Final ${
                                purchaseOption.is_event ? "Class" : "Lesson"
                            } Date: ${getFinalLessonDate}`
                        }}
                    </div>
                </div>
            </div>

            <div
                v-if="editMode.endOfCycle && !cancelAll"
                class="soli-grey pa-3 mb-3 row"
            >
                {{
                    `Final ${
                        purchaseOption.is_event ? "Class" : "Lesson"
                    } Date: ${getFinalLessonDate}`
                }}
            </div>

            <SoliDate
                v-if="editMode.changeDate"
                v-model="anchor"
                :rules="[
                    (val) => (val || '').length > 0 || 'This field is required',
                ]"
            ></SoliDate>
        </template>
    </SoliForm>
</template>

<script>
import globalMoment from "../../Mixins/GlobalMoment.js";
import confetti from "canvas-confetti";

export default {
    mixins: [globalMoment],
    props: {
        purchaseOption: {
            type: Object,
            default: null,
        },
        user: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            emailStudent: true,
            emailTeacher: true,
            editMode: {
                endOfCycle: false,
                withdraw30: false,
                cancelNow: false,
            },
            exitProration: null,
            prorationLoading: false,
            dateOfNotice: this.globalMomentDate(),
            cancelAll: null,
            finalLesson: null,
            anchor: null,
            newPrice: null,
            removeExitLoading: false,
        };
    },
    computed: {
        isMembership() {
            return this.purchaseOption.category === "memberships";
        },
        cancelAt() {
            if (!this.purchaseOption) return null;

            if (this.editMode.cancelNow) return moment(new Date());
            if (this.editMode.endOfCycle) {
                return moment(new Date(this.purchaseOption.cycle))
                    .add(-1, "days")
                    .endOf("day")
                    .format();
            }

            // add 29 instead of 30 so the end date shown is inclusive - makes more sense while processing
            return moment(new Date(this.dateOfNotice))
                .add(29, "days")
                .endOf("day")
                .format();
        },
        getFinalLessonDate() {
            if (!this.purchaseOption) return null;

            if (this.finalLesson) {
                return this.globalMomentDate(this.finalLesson);
            }
            let name = this.purchaseOption.is_event ? "classes" : "lessons";
            return `No scheduled ${name}`;
        },
        notice() {
            if (!this.purchaseOption) return null;

            if (this.editMode.endOfCycle) return this.purchaseOption.cycle;
            return moment(new Date(this.dateOfNotice)).add(1, "days").format();
        },
    },
    methods: {
        removePendingExit(purchaseOption) {
            this.removeExitLoading = true;
            this.$inertia.put(
                route("subscription.removePendingExit"),
                {
                    id: purchaseOption.id,
                },
                {
                    onSuccess: () => {
                        this.removeExitLoading = false;
                        confetti({
                            particleCount: 100,
                            spread: 70,
                            origin: { y: 0.6 },
                        });
                        this.$emit("success");
                        this.$refs.form.reset();
                    },
                    onError: (errors) => {
                        console.log(
                            "Form returned errors: " + JSON.stringify(errors)
                        );
                        this.removeExitLoading = false;
                        this.$refs.form.loading = false;
                    },
                }
            );
        },
        updateSubscription() {
            this.$inertia.put(
                route("subscription.withdraw"),
                {
                    user: this.user.id,
                    item: this.purchaseOption.id,
                    notice: this.notice,
                    anchor: this.purchaseOption.cycle,
                    cancelAt: this.cancelAt,
                    endOfCycle: this.editMode.endOfCycle,
                    cancelAll: this.cancelAll || this.editMode.cancelNow,
                    finalAmount: Number(this.exitProration),
                    emailTeacher: this.emailTeacher,
                    emailStudent: this.emailStudent,
                    lateCancelGrace: false, //TODO set toggle if cancelling all lessons to say if teacher should be paid.
                },
                {
                    onSuccess: () => {
                        this.$emit("success");
                        this.$refs.form.reset();
                    },
                    onError: (errors) => {
                        console.log(
                            "Form returned errors: " + JSON.stringify(errors)
                        );
                        this.$refs.form.loading = false;
                    },
                }
            );
        },
        getExitProration() {
            this.prorationLoading = true;
            axios
                .get(
                    route("proration", {
                        price: this.purchaseOption.price.unit_amount,
                        starts_at: moment(new Date(this.dateOfNotice)).format(),
                        anchor: this.purchaseOption.cycle,
                        notice: Number(!!this.dateOfNotice),
                        originalPrice: null,
                        alwaysProrate: 1,
                    })
                )
                .then((e) => {
                    this.exitProration = e.data.toFixed(2);
                    this.prorationLoading = false;
                });
        },
        getFinalClass() {
            this.finalClassLoading = true;
            axios
                .get(
                    route("lessons.finalClass", {
                        item: this.purchaseOption.id,
                        cancelAt: this.cancelAt,
                    })
                )
                .then((e) => {
                    this.finalClassLoading = false;
                    this.finalLesson = e.data.starts_at;
                });
        },
        getSubscriptionCycleMax(cycle) {
            //return moment(cycle).add(30, "days").format("YYYY-MM-DD");
            return moment(cycle).format("YYYY-MM-DD");
        },
    },
};
</script>

<style></style>
